import { render, staticRenderFns } from "./FormTemplateDetails.vue?vue&type=template&id=7bc11292&scoped=true&"
import script from "./FormTemplateDetails.vue?vue&type=script&lang=js&"
export * from "./FormTemplateDetails.vue?vue&type=script&lang=js&"
import style0 from "./FormTemplateDetails.vue?vue&type=style&index=0&id=7bc11292&prod&lang=scss&scoped=true&"
import style1 from "./FormTemplateDetails.vue?vue&type=style&index=1&id=7bc11292&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc11292",
  null
  
)

export default component.exports